import { Col, Form, Input } from "antd";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

const MachineConfigFilterCommon = ({ initialTableData, form }) => {
  const location = useLocation();

  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    if (form && prevPathname.current !== location.pathname) {
      form.resetFields();
      prevPathname.current = location.pathname;
    }
  }, [location.pathname, form]);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Name" name="name">
          <Input />
        </Form.Item>
      </Col>
    </>
  );
};

export default MachineConfigFilterCommon;
